import { render, staticRenderFns } from "./EditBreakpoint.vue?vue&type=template&id=5b1ec5b8&"
import script from "./EditBreakpoint.vue?vue&type=script&lang=ts&"
export * from "./EditBreakpoint.vue?vue&type=script&lang=ts&"
import style0 from "./EditBreakpoint.vue?vue&type=style&index=0&id=5b1ec5b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports